<script lang="ts">
  import Icon from './Icon.svelte'

  /**
   * Back to north-up and flat (issue #5). MapLibre lets a right-drag, a
   * ctrl-drag or a two-finger twist turn and tilt the map, and we draw none
   * of its controls, so this is the only way back short of a reload. Shown
   * only while the map is turned or tilted, as other map apps do; the needle
   * points at north, so it turns against the bearing. Placed by the layout.
   */

  let {
    bearing,
    pitch,
    onReset,
  }: { bearing: number; pitch: number; onReset: () => void } = $props()

  // Half a degree: an ease back to 0 lands on float noise, not exactly 0.
  let turned = $derived(Math.abs(bearing) > 0.5 || Math.abs(pitch) > 0.5)
</script>

{#if turned}
  <button
    type="button"
    class="wx-float-btn touch-target compass"
    aria-label="Reset map to north"
    title="Reset to north"
    onclick={onReset}
  >
    <span class="needle" style:transform="rotate({-bearing}deg)">
      <Icon name="navigation-2" size={20} filled />
    </span>
  </button>
{/if}

<style>
  .needle {
    display: grid;
    place-items: center;
  }
</style>
